import { useState, type FormEvent } from 'react';
import { Button } from '../../components/Button';
import { Field } from '../../components/Field';
import { da } from '../../i18n/da';
import { setUserBlocked } from '../auth/auth-api';
import styles from './BlockPanel.module.css';

/** For the admin: blocks a player, who is logged out and thrown out of the game at once. */
export function BlockPanel() {
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (blocked: boolean) => {
    setBusy(true);
    const result = await setUserBlocked({ username, blocked });
    setBusy(false);
    if (!result.ok) {
      setMessage(da.authErrors[result.error]);
      return;
    }
    const name = result.data.user.username;
    setMessage(blocked ? da.admin.blocked(name) : da.admin.unblocked(name));
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    void submit(true);
  };

  return (
    <form className={styles.panel} onSubmit={handleSubmit}>
      <strong>{da.admin.blockTitle}</strong>
      <div className={styles.row}>
        <Field
          label={da.admin.usernameLabel}
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
        />
        <Button type="submit" size="small" disabled={busy || !username.trim()}>
          {da.admin.block}
        </Button>
        <Button
          type="button"
          size="small"
          variant="quiet"
          disabled={busy || !username.trim()}
          onClick={() => void submit(false)}
        >
          {da.admin.unblock}
        </Button>
      </div>
      {message && (
        <p className={styles.message} role="status">
          {message}
        </p>
      )}
    </form>
  );
}
